import { createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

export const getProfile = createAsyncThunk(
  'get/profile',
  async (slug: string, { rejectWithValue }) => { 
    try {
      const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );
      const public_view = sessionStorage.getItem('view_public') || "";

      let url = `${process.env.NEXT_PUBLIC_API_PATH}profile/${slug}`;
      if (public_view === 'true') {
        url += '?view=public';
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch profile');
      }

      const data = await response.json();
      
      if (Array.isArray(data.data)) {
        return null;
      }

      return data.data

    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


export const registerWaitlist = createAsyncThunk(
  'registerWaitlist',
  async (
      { full_name, email}: { full_name: string, email: string,  },
      { rejectWithValue }
    ) => {
    try {

      // const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );
      // if (!token) {
      //   throw new Error('Authorization token not found');
      // }

      const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}register-waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', 
          // 'Authorization': `${token}`, 
        },
        body: JSON.stringify({
          full_name,
          email,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.message);
      }

      const data = await response.json();
      return data.status;

    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

